import { render, staticRenderFns } from "./infoPage.vue?vue&type=template&id=2825ef68&scoped=true&"
import script from "./infoPage.vue?vue&type=script&lang=js&"
export * from "./infoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825ef68",
  null
  
)

export default component.exports